import {
  API_DICTIONARY,
  HTTP_METHODS,
  ResponseWithPagination
} from '../../constants'
import Fetcher from '../../services/Fetcher'
import { TCommunityProcessingItem } from './types'

const fetcher = new Fetcher({})

export const fetchCommunityProcessing = async (params) =>
  fetcher.request<unknown, ResponseWithPagination<TCommunityProcessingItem>>({
    url: `${API_DICTIONARY.FINANCES}${API_DICTIONARY.SPLIT_FEES}${API_DICTIONARY.COMMUNITY_PROCESSING}${API_DICTIONARY.COMMUNITIES}`,
    method: HTTP_METHODS.GET,
    ...params
  })

export const fetchHSProcessingTable = async (uuid, params) =>
  fetcher.request<unknown, ResponseWithPagination<TCommunityProcessingItem>>({
    url: `${API_DICTIONARY.FINANCES}${API_DICTIONARY.SPLIT_FEES}${API_DICTIONARY.COMMUNITY_PROCESSING}${API_DICTIONARY.COMMUNITIES}${uuid}/${API_DICTIONARY.HEALTH_SYSTEMS}`,
    method: HTTP_METHODS.GET,
    ...params
  })

export const fetchHSListOptions = async (uuid) =>
  fetcher.request<unknown, ResponseWithPagination<TCommunityProcessingItem>>({
    url: `${API_DICTIONARY.FINANCES}${API_DICTIONARY.SPLIT_FEES}${API_DICTIONARY.COMMUNITY_PROCESSING}${API_DICTIONARY.COMMUNITIES}${uuid}/${API_DICTIONARY.HEALTH_SYSTEMS}${API_DICTIONARY.OPTIONS}`,
    method: HTTP_METHODS.GET
  })
export const editFeesHSOption = async (uuidCommunity, uuidHs, data) =>
  fetcher.request<unknown, ResponseWithPagination<TCommunityProcessingItem>>({
    url: `${API_DICTIONARY.FINANCES}${API_DICTIONARY.SPLIT_FEES}${API_DICTIONARY.COMMUNITY_PROCESSING}${API_DICTIONARY.COMMUNITIES}${uuidCommunity}/${API_DICTIONARY.HEALTH_SYSTEMS}${uuidHs}/`,
    method: HTTP_METHODS.PATCH,
    data
  })
